import { SimNaoEnum } from 'components/form'

import { ExemplosVerticalFieldModel } from '../../components/ExemplosVerticalField'
import {
  ConsultaSeguimentoAplicacaoItemModel,
  ConsultaSeguimentoOutroFieldModel,
  PassouFalhouEnum,
} from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta12ExemplosEnum {
  MAQUINA_DE_LAVAR = 'MAQUINA_DE_LAVAR',
  CHORO_DE_BEBES = 'CHORO_DE_BEBES',
  ASPIRADOR_DE_PO = 'ASPIRADOR_DE_PO',
  SECADOR_DE_CABELO = 'SECADOR_DE_CABELO',
  TRANSITO = 'TRANSITO',
  GRITO_DE_BEBES = 'GRITO_DE_BEBES',
  MUSICA_ALTA = 'MUSICA_ALTA',
  TOQUE_TELEFONE_CAMPAINHA = 'TOQUE_TELEFONE_CAMPAINHA',
  BARULHO_DE_LIQUIDIFICADOR = 'BARULHO_DE_LIQUIDIFICADOR',
  LUGARES_BARULHENTOS = 'LUGARES_BARULHENTOS',
}

export enum ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum {
  TAMPA_OUVIDOS_CALMAMENTE = 'TAMPA_OUVIDOS_CALMAMENTE',
  NAO_GOSTA_BARULHO = 'NAO_GOSTA_BARULHO',
  GRITA = 'GRITA',
  CHORA = 'CHORA',
  TAMPA_OUVIDOS = 'TAMPA_OUVIDOS',
}

export interface ConsultaSeguimentoPergunta12Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_12_HEADER?: SimNaoEnum
  PERGUNTA_12_EXEMPLOS?: Record<ConsultaSeguimentoPergunta12ExemplosEnum, SimNaoEnum>
  PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU?: ExemplosVerticalFieldModel<ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum>
  PERGUNTA_12_FREQUENCIA?: PassouFalhouEnum
  OUTRO?: ConsultaSeguimentoOutroFieldModel
}
